import { useQuery } from '@tanstack/react-query';
import { getAllExpenseTypes } from '../requests/expenseType';

const KEY = 'expenseType';

const expenseTypeQuery = {
  useGetAllExpenseTypes: (data = {}, headers = {}) => useQuery({
    queryKey: [KEY, data],
    queryFn: () => getAllExpenseTypes(data, headers),
    staleTime: 0,
    cacheTime: 0,
  }),
};
export default expenseTypeQuery;
